import * as React from 'react';
import { SocialEmbedWrapper, SocialEmbedInnerContainer } from './components';
export var SocialEmbedContainer = function (props) {
    var children = props.children;
    return (React.createElement(SocialEmbedWrapper, null,
        React.createElement(SocialEmbedInnerContainer, null, children)));
};
